import { Box, Typography, Button} from "@mui/material";
import { ReactComponent as BankStatementIcon } from '../../img/BankStatementIcon.svg';
import { MdAdd } from "react-icons/md";
import { colors } from '../../Theme/tokens';

export default function BankStatements() {
    return (
        <Box mt={2} sx={{ borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: colors.background.infoPanel, flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
                <Typography variant='h3' sx={{ lineHeight: '37px' }}>Bank Statements</Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 10 }}>
                <Box sx={{ display: 'flex', gap: '15px' }}>
                    <BankStatementIcon style={{ margin: '12px 0' }} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Box sx={{}}>
                            <Typography variant='h5_2' sx={{ color: colors.text.secondary, }}>Uploaded 21 Dec 2022</Typography>
                            <Typography variant='h4' sx={{ color: colors.text.primary, lineHeight: '30px' }}>Bank Statement Year 2022.PDF</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button disabled sx={{
                    backgroundColor: colors.primary.main, color: colors.primary.contrastText, width: '400px', '&:hover': {
                        backgroundColor: colors.primary.main
                    }
                }} variant="contained" endIcon={<MdAdd />}>
                    <Typography sx={{ textTransform: 'none', fontSize: '16px', lineHeight: '22px', fontWeight: 500, padding: '10px', borderRadius: "8px" }}>Add Bank Statement</Typography>
                </Button>
            </Box>

        </Box>
    )
}